const HTTP_SCHEME_REGEX = /^https?:\/\//i;
const PROTOCOL_RELATIVE_PREFIX = '//';

const getTrimmed = (value?: string | null): string => (value || '').trim();

// Single normalizer for config URLs and redirect routes.
// - /route stays internal
// - http(s):// stays unchanged
// - domain-like values get https://
export function normalizeUrlOrRoute(value?: string | null): string {
    const trimmedValue = getTrimmed(value);

    if (!trimmedValue) return trimmedValue;
    if (trimmedValue.startsWith('/')) return trimmedValue;
    if (HTTP_SCHEME_REGEX.test(trimmedValue)) return trimmedValue;
    if (trimmedValue.startsWith(PROTOCOL_RELATIVE_PREFIX)) return `https:${trimmedValue}`;

    return `https://${trimmedValue}`;
}
